import { useNavigate } from 'react-router-dom';
import './homeButton.css'
import { useTranslation } from 'react-i18next';


export function HomeButton() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <button className="home-button" onClick={() => navigate('/home')}>
        <svg xmlns="http://www.w3.org/2000/svg"
          width="24" height="24" viewBox="0 0 24 24"
          fill="none" stroke="#000" strokeWidth="2"
          strokeLinecap="round" strokeLinejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
      </button>
    </>

  );
}
